import React from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import ClassNames from "classnames"

export default function (Component) {
  const ValidationMixin = createReactClass({
    propTypes: {
      className: PropTypes.string,
      isNotValid: PropTypes.bool,
    },
    getClass() {
      return ClassNames({ notValid: this.props.isNotValid }, this.props.className)
    },
    render() {
      return <Component {...this.props} {...this.state} className={this.getClass()} />
    },
  })
  return ValidationMixin
}
